import { Pipe, PipeTransform } from '@angular/core'
import { CroptypeColor } from '@agroone/entities'
import { requireDefined } from '../utils/require-defined.util'

@Pipe({
  name: 'cropTypeColor',
})
export class CropTypeColorPipe implements PipeTransform {
  DEFAULT_COLOR: string = 'grey'

  transform(cropType: string, croptypeColors: CroptypeColor[] | undefined): string {
    if (Array.isArray(croptypeColors) && cropType) {
      return (
        croptypeColors.find(
          (c: CroptypeColor) =>
            requireDefined(c.croptype, 'the croptype of a croptype color').toLowerCase() === cropType.toLowerCase(),
        )?.color || this.DEFAULT_COLOR
      )
    }

    return this.DEFAULT_COLOR
  }
}
